import { DriverWidgetProps, SelectedDriversFilterContext } from "./common";
import { useContext, useEffect, useState } from "react";
import { Button, Loading, Title } from "react-admin";
import {
  SafetyDashboardApiFactory,
  SafetyDashboardDriverDto,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { handleAxiosError } from "../../../common/data/axiosErrorHandler";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { ArrowBack } from "@material-ui/icons";
import { Breadcrumb } from "./Breadcrumb";
import { SelectedDriversSlide } from "./SelectedDriversSlide";
import { GridLayoutWidget } from "../../assets/maintenance-dashboard/common";
import { DriverInfoWidget } from "./driver-widgets/DriverInfoWidget";
import { UnresolvedDriverDvirDefects } from "./driver-widgets/UnresolvedDriverDvirDefects";
import { DriverGeometrisAlerts } from "./driver-widgets/DriverGeometrisAlerts";
import { DriverHarshEventsBreakdown } from "./driver-widgets/DriverHarshEventsBreakdown";
import { DriverSpeedingEvents } from "./driver-widgets/DriverSpeedingEvents";
import "./DriverSafetyDashboard.css";

const widgets: GridLayoutWidget<DriverWidgetProps>[] = [
  {
    i: "driverInfo",
    Widget: DriverInfoWidget,
    icon: "info",
    title: "Driver info",
  },
  {
    i: "speedingEvents",
    Widget: DriverSpeedingEvents,
    icon: "error",
    title: "Speeding occurrences",
  },
  {
    i: "harshEvents",
    Widget: DriverHarshEventsBreakdown,
    icon: "error",
    title: "Total safety alerts",
  },
  {
    i: "geometrisAlerts",
    Widget: DriverGeometrisAlerts,
    icon: "warning",
    title: "Safety alerts",
  },
  {
    i: "vehicleDvirDefects",
    Widget: UnresolvedDriverDvirDefects,
    icon: "warning",
    title: "Unresolved DVIR defects",
  },
];

interface Props {
  driverId?: number;
}

export const DriverSafetyDashboard = ({ driverId }: Props) => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(true);
  const [driver, setDriver] = useState<SafetyDashboardDriverDto>();
  const axios = useAxiosInstance();
  const context = useContext(SelectedDriversFilterContext);
  const sidebarVisible = !!context?.selectedFilter;

  useEffect(() => {
    if (!driverId) {
      return;
    }

    if (!axios) {
      return;
    }

    setLoading(true);
    SafetyDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppSafetydashboardIdDriverGet(driverId)
      .then((response) => setDriver(response.data))
      .catch((e) => console.error(handleAxiosError(e)))
      .finally(() => setLoading(false));
  }, [driverId, axios]);

  return loading ? (
    <Loading />
  ) : driver ? (
    <div className="maintenance-dashboard">
      <Title
        title={
          <Breadcrumb driver={{ ...driver, driverName: driver.fullName }} />
        }
      />
      <section className="widgets-header">
        <>
          <Button
            onClick={() => history.push(`/${resourceNames.SAFETY_DASHBOARD}`)}
            label="Return to dashboard">
            <ArrowBack />
          </Button>
        </>
      </section>
      <div className="driver-safety-dashboard">
        {widgets.map((x) => {
          return (
            <x.Widget key={x.i} icon={x.icon} title={x.title} driver={driver} />
          );
        })}
        {sidebarVisible ? <SelectedDriversSlide /> : null}
      </div>
    </div>
  ) : null;
};
